import { useTranslation } from 'react-i18next'

import {
  FieldGroup,
  FieldGroupHeader,
  FieldRow,
  FieldSkeleton,
  FieldsTable,
  FieldViewValue,
} from '@/components/layout/field-row'
import { TabCard } from '@/components/layout/tab-card'

import {
  getPlaceGeneralLayout,
  getPlaceGeneralRowLabelKey,
  PLACE_GENERAL_FLAG_ROWS,
  PlaceGeneralFlagKey,
} from './general-tab.constants'

// Note: the same size for every value, so all rows look alike and sit in the row's 4.8rem minimum height
const VALUE_WIDTH = '20rem'
const VALUE_HEIGHT = '1.6rem'

// Note: title, group headers and row labels are static, so they are real text - only the values
// are skeletons
export const GeneralTabSkeleton = ({ isAdmin }: { isAdmin: boolean }) => {
  const { t } = useTranslation(['organisation'])

  return (
    <TabCard title={t('organisation:places.general.title')}>
      <FieldsTable aria-hidden>
        {getPlaceGeneralLayout(isAdmin).map(({ group, rows }) => (
          <FieldGroup key={group}>
            <FieldGroupHeader>{t(`organisation:places.general.groups.${group}`)}</FieldGroupHeader>
            {rows.map((row) => (
              <FieldRow
                key={row}
                label={
                  PLACE_GENERAL_FLAG_ROWS.includes(row)
                    ? t(`organisation:places.building.toggles.${row as PlaceGeneralFlagKey}`)
                    : t(getPlaceGeneralRowLabelKey(row))
                }
              >
                <FieldViewValue>
                  <FieldSkeleton height={VALUE_HEIGHT} width={VALUE_WIDTH} />
                </FieldViewValue>
              </FieldRow>
            ))}
          </FieldGroup>
        ))}
      </FieldsTable>
    </TabCard>
  )
}
